import { render, staticRenderFns } from "./PAShowCoverageInfo.vue?vue&type=template&id=7820946f"
import script from "./PAShowCoverageInfo.vue?vue&type=script&lang=js"
export * from "./PAShowCoverageInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports